import UserSlice from "../redux/admin-slices/user.slice";

class UserServices {
  static dispatch = null;
  constructor(dispatch) {
    if (!dispatch) {
      throw new Error("UserServices: dispatch is required. Pass Redux dispatch while creating the service.")
    }

    this.dispatch = dispatch
    this.userSlice = new UserSlice()
  }

  // Enable user's status
  async enableUser({ id }) {
    return await this.dispatch(
      this.userSlice.enableUser({ id })
    ).unwrap()
  }

  // Disable user's status
  async disableUser({ id, reason }) {
    return await this.dispatch(
      this.userSlice.disableUser({ id, reason })
      // _updateMembertStatus({ id, status: false, reason })
    ).unwrap()
  }
}

export default UserServices